import { Injectable } from '@angular/core';
import { CARGOCHIEF_KEYS } from '@domain/constants/app-variables';
import { Cargochief } from '@service/cargochief/cargochief.service';
import {
	DATE_MDY,
	INTEGRATION_TYPE,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	VETTING_SOURCE,
} from 'cargo-chief-commons';

@Injectable({
	providedIn: 'root',
})
export class CarrierVettingService {
	constructor(private cargochief: Cargochief) {}

	logo(vettingSource: VETTING_SOURCE) {
		switch (vettingSource) {
			case VETTING_SOURCE.MY_CARRIER_PACKETS:
				return 'assets/icons/mcp_logo.png';
			case VETTING_SOURCE.RMIS:
				return 'assets/icons/rmis_logo.svg';
			case VETTING_SOURCE.HIGHWAY:
				return 'assets/icons/2025_Highway H logo.png';
			case VETTING_SOURCE.C4:
			default:
				return 'assets/icons/network.svg';
		}
	}

	tooltip(vettingSource: VETTING_SOURCE, carrierOnboardedOn: Date, lastVettingTime: Date) {
		const onboardedDate = DATE_MDY(carrierOnboardedOn);
		const lastVettingDate = DATE_MDY(lastVettingTime);

		switch (vettingSource) {
			case VETTING_SOURCE.MY_CARRIER_PACKETS:
				if (!carrierOnboardedOn) {
					return `Carrier Onboarded: N/A\nLast Sync with MCP: ${lastVettingDate}`;
				} else {
					return `Carrier Onboarded: ${onboardedDate}\nLast Sync with MCP: ${lastVettingDate}`;
				}
			case VETTING_SOURCE.RMIS:
				return `Onboarded with RMIS: ${onboardedDate}`;
			case VETTING_SOURCE.HIGHWAY:
				if (!carrierOnboardedOn) {
					return `Carrier Onboarded: N/A\nLast Sync with Highway: ${lastVettingDate}`;
				} else {
					return `Carrier Onboarded: ${onboardedDate}\nLast Sync with Highway: ${lastVettingDate}`;
				}
			case VETTING_SOURCE.C4:
				return `Added from C4: ${onboardedDate}`;
			default:
				return '';
		}
	}

	isMCPEnabled() {
		const activeIntegrations = this.cargochief.getActiveIntegrations();
		return (
			IS_NOT_NULL_OR_UNDEFINED(activeIntegrations) &&
			activeIntegrations.includes(INTEGRATION_TYPE.MY_CARRIER_PACKETS)
		);
	}

	isRMISEnabled() {
		const activeIntegrations = this.cargochief.getActiveIntegrations();
		return (
			IS_NOT_NULL_OR_UNDEFINED(activeIntegrations) &&
			activeIntegrations.includes(INTEGRATION_TYPE.RMIS)
		);
	}

	isHighwayEnabled() {
		const activeIntegrations = this.cargochief.getActiveIntegrations();
		return (
			IS_NOT_NULL_OR_UNDEFINED(activeIntegrations) &&
			activeIntegrations.includes(INTEGRATION_TYPE.HIGHWAY)
		);
	}

	isCarrierOnboarded(carrierId: string): boolean {
		const onboardedCarriers = this.cargochief.getItem(CARGOCHIEF_KEYS.ONBOARDED_CARRIERS);
		if (IS_NOT_NULL_OR_UNDEFINED(onboardedCarriers)) {
			const onboardedCarriersList = JSON.parse(onboardedCarriers);
			return onboardedCarriersList.includes(carrierId);
		}
		return false;
	}

	carrierInvitationSent(carrierId: string): void {
		let onboardedCarriers: any = this.cargochief.getItem(CARGOCHIEF_KEYS.ONBOARDED_CARRIERS);
		if (IS_NULL_OR_UNDEFINED(onboardedCarriers)) {
			onboardedCarriers = [carrierId];
		} else {
			onboardedCarriers = JSON.parse(onboardedCarriers);
			onboardedCarriers.push(carrierId);
		}
		this.cargochief.setItem({ [CARGOCHIEF_KEYS.ONBOARDED_CARRIERS]: onboardedCarriers });
	}

	isSameVettingSourceAndActiveIntegration(vettingSource: VETTING_SOURCE) {
		const activeIntegrations = this.cargochief.getActiveIntegrations();
		if (!activeIntegrations.length) {
			return true;
		}
		return (
			IS_NOT_NULL_OR_UNDEFINED(activeIntegrations) && activeIntegrations.includes(vettingSource)
		);
	}
}
